import { Header, type NavItemInterface } from '../../base/Header'
import { Footer } from '../../base/Footer'
import { paths } from '@/configs/paths'

import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

const SystemOwnerLayout = ({ children }) => {
  const { t } = useTranslation()

  const navItems: NavItemInterface[] = useMemo(
    () => [
      {
        label: t('Master' as any),
        subItems: [
          { label: t('Distributor' as any), href: paths.distributorManage.path },
          { label: t('Customer' as any), href: paths.customerMaster.path }
        ]
      }
    ],
    [t]
  )

  return (
    <div className='flex flex-col min-h-screen bg-[#F8FAFF]'>
      <Header navItems={navItems} />
      <main className='flex-1 p-3 py-2 xl:p-5 mt-14'>{children}</main>
      <Footer />
    </div>
  )
}

export default SystemOwnerLayout
